
<section class="wrapper">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      Are you sure you want to delete the following category?
    </h1>
  </section>
  <section mat-dialog-content>
    <h1>{{ Category.title }}</h1>
  </section>
  <section align="end" mat-dialog-actions>
    <button
      mat-button
      mat-dialog-close
      matTooltip="Cancel and close."
      type="button"
    >
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <button
      mat-button
      matTooltip="Delete category"
      (click)="deleteCategory(Category)"
    >
      <mat-icon>done</mat-icon>
      Done
    </button>
  </section>
</section>
